import { CAMPAIGN_STEP_NONE, CAMPAIGN_STEP_COMPLETE, CAMPAIGN_STEP_REFUSED } from '../reducers/ui/campaignStep';

export const campaignModalStateSelector = (state) => state.ui.campaignModal;
export const campaignEntrySourceSelector = (state) => state.ui.campaignSource;
export const campaignStepSelector = (state) => state.ui.campaignStep;
export const isCampaignAttendedSelector = (state) => 
  state.ui.campaignStep !== CAMPAIGN_STEP_NONE &&
  state.ui.campaignStep !== CAMPAIGN_STEP_COMPLETE &&
  state.ui.campaignStep !== CAMPAIGN_STEP_REFUSED;